import React from 'react'
import { Dropdown } from 'react-bootstrap'
import { APPConfig } from 'config/appConfig'
import debounce from 'lodash/debounce'
import { FaChevronDown as DownArrow } from 'react-icons/fa'
import { getFrequenciesBasedOnAdminConfig } from 'src/deps/NuskinSubscriptionDeps'
import { i18nTranslate, enablePdpRedesign } from 'src/utils'
import './styles.scss'

class FrequencyDropdownV2 extends React.Component {
  constructor(props) {
    super(props)
    const isToEnableOneTimeFrequency =
      APPConfig?.getAppConfig()?.oneTimeFrequencyEnabled === 'true'
    let {
      frequencyPeriod = 1,
      frequencyType = 'Every month',
      orderType = 'VARIABLE_MULTI_ORDER',
      isFromPDP = false,
      isToHideMonthlyFrequency = false,
      isMonthlyLabel = false,
    } = this.props
    const frequencyValue = `${frequencyPeriod}-${frequencyType}`
    let frequenciesBasedOnAdminConfig = getFrequenciesBasedOnAdminConfig({
      isFromPDP,
      isToHideMonthlyFrequency,
      isMonthlyLabel,
    })
    let value = frequenciesBasedOnAdminConfig[0]?.value
    let label = frequenciesBasedOnAdminConfig[0]?.label
    let isOneTime = false
    if (!isToEnableOneTimeFrequency) {
      frequenciesBasedOnAdminConfig = frequenciesBasedOnAdminConfig?.filter(
        item => {
          return !(item?.isOneTime === true)
        }
      )
      value = frequenciesBasedOnAdminConfig[0].value
      label = frequenciesBasedOnAdminConfig[0].label
    }
    const subscriptionVal = frequenciesBasedOnAdminConfig.filter(
      item => frequencyValue == item.value
    )

    if (subscriptionVal.length) {
      if (subscriptionVal.length === 1) {
        value = subscriptionVal[0].value
        label = subscriptionVal[0].label
      } else {
        if (orderType === 'VARIABLE_SINGLE_ORDER') {
          value = subscriptionVal[1].value
          label = subscriptionVal[1].label
          isOneTime = subscriptionVal?.[1]?.isOneTime || false
        } else {
          value = subscriptionVal[0].value
          label = subscriptionVal[0].label
        }
      }
    }
    this.state = {
      selectedValue: value,
      selectedLabel: label,
      isSelectedOneTime: isOneTime,
      frequenciesBasedOnAdminConfig,
    }
  }

  static getDerivedStateFromProps(props, state) {
    if (props.enabledNewPdp) {
      if (props.selectedFrequencyLabel !== state.selectedLabel) {
        return {
          selectedLabel: props.selectedFrequencyLabel,
        }
      }
      return null
    }
  }

  // using the callback function from props to set and reset values
  componentDidMount = () => {
    const { handleFrequencyDidMount } = this.props
    typeof handleFrequencyDidMount === 'function' && handleFrequencyDidMount()
  }

  componentWillUnMount = () => {
    const { handleFrequencyUnmount } = this.props
    typeof handleFrequencyUnmount === 'function' && handleFrequencyUnmount()
  }
  setDropDown = async (
    value = '1-MONTHS',
    label = 'Monthly',
    isOneTime = false,
    isMonthly = false,
    event
  ) => {
    const { handleSubscriptionFrequency = () => {}, isValidateReturn = false } =
      this.props
    if (isValidateReturn) {
      if (handleSubscriptionFrequency(value, isOneTime)) {
        this.setState({ selectedValue: value, selectedLabel: label })
      }
    } else {
      this.setState({ selectedValue: value, selectedLabel: label })
      typeof handleSubscriptionFrequency === 'function' &&
        handleSubscriptionFrequency(value, isOneTime)
    }
  }
  render() {
    const {
      title = '',
      disableTabIndex = 0,
      isAlreadySubscribed = false,
    } = this.props
    const items = this.state.frequenciesBasedOnAdminConfig.map(item => {
      const isSelectedClass =
        item.value === this.props.selectedValue ? 'selected' : ''
      return (
        <Dropdown.Item
          as="button"
          key={item.label}
          value={item.isOneTime === true ? 'MONTHLY' : item.value}
          className={isSelectedClass}
          disabled={
            this.props?.isFromModal &&
            item?.isOneTime === true &&
            itemType === 'VARIABLE_SINGLE_ORDER'
          }
          aria-label={item.label}
          onClick={debounce(event => {
            this.setDropDown(
              item.value,
              item.label,
              item?.isOneTime,
              item?.isMonthly,
              event
            )
          }, 700)}
          onKeyPress={debounce(event => {
            this.setDropDown(
              item.value,
              item.label,
              item?.isOneTime,
              item?.isMonthly,
              event
            )
          }, 700)}
          data-testid="qa-subscription-label">
          {item.label}
        </Dropdown.Item>
      )
    })
    return (
      <Dropdown
        className="subscription-dropdown-nuskin"
        data-testid="frequency-dropdown"
        aria-label={
          isAlreadySubscribed
            ? i18nTranslate('pdp.frequencyDisabled', 'Frequency Disabled', {
                nameSpace: 'ssr-resource',
              })
            : i18nTranslate('pdp.selectFrequency', 'Select Frequency', {
                nameSpace: 'ssr-resource',
              })
        }
        disabled={isAlreadySubscribed}
        aria-disabled={isAlreadySubscribed}
        drop={`${enablePdpRedesign() ? 'up' : 'down'}`}>
        <Dropdown.Toggle
          className="d-flex subscription-dropdown-toggle"
          tabIndex={disableTabIndex}
          aria-label={
            isAlreadySubscribed
              ? i18nTranslate('pdp.frequencyDisabled', 'Frequency Disabled', {
                  nameSpace: 'ssr-resource',
                })
              : `${i18nTranslate('pdp.selectFrequency', 'Select Frequency', {
                  nameSpace: 'ssr-resource',
                })}: ${this.state.selectedLabel}`
          }
          aria-haspopup={!isAlreadySubscribed}
          aria-expanded={!isAlreadySubscribed ? undefined : false}>
          <div
            className="dropdown-left-section"
            aria-disabled={isAlreadySubscribed}
            aria-label={
              isAlreadySubscribed
                ? i18nTranslate('pdp.frequencyDisabled', 'Frequency Disabled', {
                    nameSpace: 'ssr-resource',
                  })
                : i18nTranslate('pdp.selectFrequency', 'Select Frequency', {
                    nameSpace: 'ssr-resource',
                  })
            }>
            {title && <span className="dropdown-nuskin-title">{title}</span>}
            <span
              className="dropdown-nuskin-value mt-1"
              data-testid="frequency-value">
              {this.state.selectedLabel}
            </span>
          </div>
          <div className="dropdown-right-section">
            <DownArrow name="arrows" />
          </div>
        </Dropdown.Toggle>
        {!isAlreadySubscribed && (
          <Dropdown.Menu className="subscription-dropdownmenu z-1">
            {items}
          </Dropdown.Menu>
        )}
      </Dropdown>
    )
  }
}
export default FrequencyDropdownV2
export { FrequencyDropdownV2 }
